import { Box, Button, Typography } from '@mui/material';
import React, { useEffect, useRef, useState } from 'react';
import { theme } from '../../../../theme';
import CreateTwoToneIcon from '@mui/icons-material/CreateTwoTone';
import { useParams } from 'react-router-dom';
import { getOfferLetter } from './preboardingConfigurationApi';
import ReactQuill from 'react-quill';
import EditOfferLetterDialog from './EditOfferLetterDialog';
import { removeSpacing, sanitizeContent } from '../../../Common/Sanitize/sanitizeReactQuill';
import { saveEmailTemplate } from '../Communication/communicationApi';
import { useSnackbar } from '../../../../Context/SnackbarContext';

const OfferLetterSetup = () => {
  const [emailSubject, setEmailSubject] = useState('');
  const [emailNum, setEmailNum] = useState(0);
  const [emailBody, setEmailBody] = useState('');
  const [editedEmailBody, setEditedEmailBody] = useState('');
  const { tenant } = useParams<{ tenant: string }>();
  const [isEdit, setIsEdit] = useState(false);
  const quillRef = useRef<ReactQuill>(null);
  const [errorMessage, setErrorMessage] = useState('');
  const { showSnackbar } = useSnackbar();

  const fetchOfferLetter = async () => {
    const result = await getOfferLetter(tenant);
    if (result) {
      setEmailNum(result.EmailNum);
      setEmailSubject(result.EmailSubject);
      setEmailBody(result.EmailBody);
    }
  };
  useEffect(() => {
    fetchOfferLetter();
  }, [tenant]);

  const quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      ['link'],
      [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
      [{ indent: '-1' }, { indent: '+1' }],
    ],
    clipboard: {
      matchVisual: false,
    },
  };

  const handleSave = async () => {
    const sanitizedValue = sanitizeContent(editedEmailBody);
    if (!sanitizedValue) {
      setErrorMessage('Offer letter content cannot be empty.');
      return;
    }
    const body = removeSpacing(editedEmailBody);
    const payLoad = {
      EmailSubject: emailSubject,
      EmailBody: body,
      EmailNum: emailNum,
    };
    try {
      const response = await saveEmailTemplate(tenant, payLoad);
      if (response) {
        showSnackbar('Offer letter template has be updated', 'success');
        fetchOfferLetter();
      }
    } catch (error) {
      showSnackbar(
        'Failed to update the email template. Please try again.',
        'error'
      );
      console.error(error);
    } finally {
      setIsEdit(false);
    }
  };

  return (
    <Box sx={{ position: 'relative' }}>
      <Box sx={{ position: 'absolute', right: '0vw', mt: '1.4vw', top: '-3.62vw' }}>
        <Button
          variant="outlined"
          startIcon={<CreateTwoToneIcon sx={{ fontSize: '0.8vw' }} />}
          sx={{
            color: theme.palette.primary.main,
            borderColor: theme.palette.primary.main,
          }}
          onClick={() => {
            setEditedEmailBody(emailBody);
            setIsEdit(true);
          }}
        >
          Edit
        </Button>
      </Box>
      <Box sx={{ bgcolor: theme.palette.primary.light, width: '87.917vw', mt: '1vw' }}>
        <Typography variant='subtitle1' p={'1vw'}>
          Fields marked with “@” (<Box component="span" fontWeight="bold">e.g., @CandidateName, @JobTitle</Box>) are system-generated placeholders and auto-filled. Do not modify or remove them to ensure accurate data in the final offer letter.
        </Typography>
      </Box>
      <Typography variant='h6' mt='1vw' sx={{ fontWeight: 'bold' }}>
        Offer Letter
      </Typography>
      <Box mt='1vw' dangerouslySetInnerHTML={{ __html: emailBody }} />
      {/* Edit Dialog */}
      <EditOfferLetterDialog
        open={isEdit}
        onCancel={() => setIsEdit(false)}
        onSave={handleSave}
        quillRef={quillRef}
        editedEmailBody={editedEmailBody}
        setEditedEmailBody={setEditedEmailBody}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
        quillModules={quillModules}
      />
    </Box>
  );
};

export default OfferLetterSetup;